import * as React from 'react';
import { PlaceTag } from './PlaceTag';
import './TruncatedTagList.css';

export interface TruncatedTagListItem {
  key: string;
  label: string;
}

interface TruncatedTagListProps {
  items: TruncatedTagListItem[];
  /** 札として並べる数。これより多い分は「他 N 件」にまとめる */
  visibleCount: number;
  /** 「他 N 件」の「件」の部分。人を数えるときは「人」にする */
  unit: string;
}

/**
 * 詳細の表示で、タグや作業者のような値を札で並べる。多いときは最初の visibleCount 個だけを札にし、残りを「他 N 件」にまとめる。
 * 「他 N 件」を押すと、まとめた分をすべて並べた吹き出しを開く。マウスを重ねられないタブレットでも見られるよう、押して開く形にする。
 * 吹き出しは、もう一度押すか、外側を押すか、Escキーで閉じる
 */
export const TruncatedTagList: React.FC<TruncatedTagListProps> = function (props) {
  const [open, setOpen] = React.useState<boolean>(false);
  const moreRef = React.useRef<HTMLSpanElement>(null);

  // 吹き出しの外を押したら閉じる
  React.useEffect(() => {
    if (!open) {
      return;
    }
    const onMouseDown = (event: MouseEvent) => {
      if (moreRef.current && !moreRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onMouseDown);
    return () => document.removeEventListener('mousedown', onMouseDown);
  }, [open]);

  const visibleItems = props.items.slice(0, props.visibleCount);
  const hiddenItems = props.items.slice(props.visibleCount);

  let more;
  if (hiddenItems.length > 0) {
    let popup;
    if (open) {
      popup = (
        <span className="TruncatedTagList-popup" role="dialog" aria-label={`残りの${hiddenItems.length}${props.unit}`}>
          {hiddenItems.map(item => (
            <PlaceTag key={item.key}>{item.label}</PlaceTag>
          ))}
        </span>
      );
    }
    more = (
      <span
        className="TruncatedTagList-more_container"
        ref={moreRef}
        onKeyDown={event => {
          if (event.key === 'Escape') {
            setOpen(false);
          }
        }}
      >
        <button
          type="button"
          className="TruncatedTagList-more"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          他 {hiddenItems.length} {props.unit}
        </button>
        {popup}
      </span>
    );
  }

  return (
    <div className="TruncatedTagList">
      {visibleItems.map(item => (
        <PlaceTag key={item.key}>{item.label}</PlaceTag>
      ))}
      {more}
    </div>
  );
};
